module.exports = __webpack_public_path__ + "img/WechatIMG29616.123f9568.png";